import React from 'react';
import { accountSearchColumns, QUERY_KEYS } from '@/constants';
import { SearchField } from '@/components/custom/erp';
import { AccountModel } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface DetailTabProps {
  formMode: FormMode;
}

const DetailTab = ({ formMode }: DetailTabProps) => {
  return (
    <div className='p-4'>
      <div className='flex items-center'>
        <Label className='w-[150px]'>Tài khoản nợ</Label>
        <SearchField<AccountModel>
          type='text'
          name='tk_no'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={accountSearchColumns}
          columnDisplay='code'
          displayRelatedField='name'
          dialogTitle='Danh mục tài khoản'
          className='w-[205px]'
        />
      </div>
    </div>
  );
};

export default DetailTab;
